var _circle, _rect, _path, _path2, _rect2, _path3, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 194,
    viewBox: "0 0 195 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 97,
    r: 97,
    fill: "#E9ECEB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 46.8682,
    width: 96.533,
    height: 107.725,
    rx: 6.5,
    fill: "white",
    stroke: "#B2B2B3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.989 144.056C143.038 144.056 153.617 133.478 153.617 120.428C153.617 107.379 143.038 96.7998 129.989 96.7998C116.939 96.7998 106.36 107.379 106.36 120.428C106.36 133.478 116.939 144.056 129.989 144.056Z",
    stroke: "#B2B2B3",
    strokeWidth: 4.7967,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M159.524 149.963L146.676 137.115",
    stroke: "#B2B2B3",
    strokeWidth: 4.7967,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 78.5,
    y: 65,
    width: 46,
    height: 4,
    rx: 2,
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5639 65.599L68.9948 64.3471L67.7429 63.778L68.9948 63.209L69.5639 61.9571L70.1329 63.209L71.3848 63.778L70.1329 64.3471L69.5639 65.599ZM66.8324 61.9571L65.9675 60.0906L64.101 59.2256L65.9675 58.3606L66.8324 56.4941L67.6974 58.3606L69.5639 59.2256L67.6974 60.0906L66.8324 61.9571ZM57.7276 76.5248C57.2268 76.5248 56.7981 76.3465 56.4415 75.9899C56.0849 75.6333 55.9066 75.2046 55.9066 74.7038H59.5485C59.5485 75.2046 59.3702 75.6333 59.0136 75.9899C58.657 76.3465 58.2283 76.5248 57.7276 76.5248ZM54.0856 73.7934V71.9724H61.3695V73.7934H54.0856ZM54.3132 71.0619C53.2662 70.4397 52.4354 69.6051 51.8208 68.5581C51.2062 67.511 50.8989 66.3729 50.8989 65.1438C50.8989 63.2469 51.5628 61.6346 52.8906 60.3068C54.2184 58.979 55.8307 58.3151 57.7276 58.3151C59.6244 58.3151 61.2367 58.979 62.5645 60.3068C63.8923 61.6346 64.5562 63.2469 64.5562 65.1438C64.5562 66.3729 64.2489 67.511 63.6343 68.5581C63.0198 69.6051 62.1889 70.4397 61.1419 71.0619H54.3132ZM54.8595 69.2409H60.5956C61.2785 68.7553 61.8058 68.1559 62.1776 67.4427C62.5493 66.7295 62.7352 65.9632 62.7352 65.1438C62.7352 63.7477 62.2496 62.564 61.2785 61.5929C60.3073 60.6217 59.1236 60.1361 57.7276 60.1361C56.3315 60.1361 55.1479 60.6217 54.1767 61.5929C53.2055 62.564 52.7199 63.7477 52.7199 65.1438C52.7199 65.9632 52.9058 66.7295 53.2776 67.4427C53.6494 68.1559 54.1767 68.7553 54.8595 69.2409Z",
    fill: "#B2B2B3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 75.5,
    y: 44,
    width: 34,
    height: 7,
    fill: "#B2B2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/NoData.c6a97cf5f58fe9ac12110fd151ddee6e.svg";
export { ForwardRef as ReactComponent };